import flatpickr from "flatpickr";
import "flatpickr/dist/l10n/hu.js";

function CreateDefaultDateConfig(): flatpickr.Options.Options {
    return {
        locale: 'hu',
        allowInput: true,
        dateFormat: 'Y. m. d.'
    };
}

function CreateDefaultDateTimeConfig(): flatpickr.Options.Options {
    return {
        locale: 'hu',
        allowInput: true,
        dateFormat: 'Y. m. d. H:i',
        enableTime: true,
        time_24hr: true
    };
}

export function InitDatepickers() {

    // Init date pickers.
    $("input.datepicker, div.datepicker input, td.datepicker input").each(function () {
        let dateConfig = CreateDefaultDateConfig();

        let maxDate = $(this).data("max-date");
        if (maxDate != undefined) {
            dateConfig.maxDate = flatpickr.parseDate(maxDate, dateConfig.dateFormat);
        }

        let minDate = $(this).data("min-date");
        if (minDate != undefined) {
            dateConfig.minDate = flatpickr.parseDate(minDate, dateConfig.dateFormat);
        }

        let defaultDate = $(this).val() || $(this).data('default-date');
        if (defaultDate != undefined) {
            dateConfig.defaultDate = flatpickr.parseDate(defaultDate, dateConfig.dateFormat);
        }

        flatpickr(this, dateConfig);
    });

    // Init datetime pickers.
    $("input.datetimepicker, div.datetimepicker input, td.datetimepicker input").each(function () {
        let dateTimeConfig = CreateDefaultDateTimeConfig();

        let maxDate = $(this).data("max-date");
        if (maxDate != undefined) {
            dateTimeConfig.maxDate = flatpickr.parseDate(maxDate, dateTimeConfig.dateFormat);
        }

        let minDate = $(this).data("min-date");
        if (minDate != undefined) {
            dateTimeConfig.minDate = flatpickr.parseDate(minDate, dateTimeConfig.dateFormat);
        }

        let defaultDate = $(this).val() || $(this).data('default-date');
        if (defaultDate != undefined) {
            dateTimeConfig.defaultDate = flatpickr.parseDate(defaultDate, dateTimeConfig.dateFormat);
        }

        flatpickr(this, dateTimeConfig);
    });
}

export function RemoveDatepickers() {
    $("input.datepicker, div.datepicker input, td.datepicker input", "input.datetimepicker, div.datetimepicker input, td.datetimepicker input").each(() => {
        flatpickr(this).destroy();
    });
}

$(function () {
    InitDatepickers();

    $(document).on('DatePickerInit', function () {
        InitDatepickers();
    });

    $(document).on('DatePickerRemove', function () {
        RemoveDatepickers();
    });
});
